// Transforme une string avec décimal avec 2 chiffres après la virgule en integer ('20,00' => 2000)
export const stringToIntegerCents = (str) => {
  if (str === null || str === undefined) return null
  const s = String(str).trim()
  if (s === '') return 0
  const numeric = s.replace(/[.,]/g, '')
  const n = Number.parseInt(numeric, 10)
  return Number.isFinite(n) ? n : 0
}

// Transforme un integer en décimal avec 2 chiffres après la virgule (2000 => 20,00)
export const integerCentsToString = (value) => {
  if (value === null || value === undefined) return ''
  const raw = String(value).trim()
  if (raw === '') return ''

  // Déjà formaté "xx,yy"
  if (/^\d{1,3}(?:\s?\d{3})*,\d{2}$/.test(raw) || /^\d+,\d{2}$/.test(raw)) {
    return raw
  }

  // Entier en centimes
  if (/^\d+$/.test(raw)) {
    const n = Number.parseInt(raw, 10)
    if (!Number.isFinite(n)) return ''
    const euros = Math.floor(n / 100)
    const cents = String(n % 100).padStart(2, '0')
    return `${euros.toLocaleString('fr-FR')},${cents}`
  }

  return raw
}
